<ng-template #tooltipTemplate let-anchor>
   <div class="tt-helper" [innerHTML]="value | highlightText$: searchValues | async | safeHtml"></div>
</ng-template>

<div
   class="sam-ellipsis-on-overflow"
   kendoTooltip
   showOn="none"
   [tooltipTemplate]="tooltipTemplate"
   [position]="position"
   #cellTooltipDirective="kendoTooltip"
   (mouseover)="showTooltip($event)"
   (mouseout)="hideTooltip()"
   [innerHTML]="value | highlightText$: searchValues | async | safeHtml"
></div>
